/**
 * Authoritative per-country E.164 samples used to probe /app-api/rate.
 *
 * The App API (ASTPP) is the single source of truth for display == billing
 * rates. Any surface that shows a per-country rate MUST probe with a
 * representative in-country number and render the returned AUD value —
 * never the legacy voice_routes cents value.
 */

export const AUTHORITATIVE_RATE_SAMPLES: Record<
  string,
  { landline?: string; mobile?: string }
> = {
  "211": { landline: "211920000000", mobile: "211920000000" },
  "249": { landline: "249912000000", mobile: "249912000000" },
  "251": { landline: "251111000000", mobile: "251911000000" },
  "234": { landline: "23412000000", mobile: "2348030000000" },
  "254": { landline: "254202000000", mobile: "254712000000" },
  "256": { landline: "256312000000", mobile: "256772000000" },
  "255": { landline: "255222000000", mobile: "255754000000" },
  "250": { landline: "250252000000", mobile: "250788000000" },
  "257": { landline: "25722200000", mobile: "25779000000" },
  "243": { landline: "243120000000", mobile: "243820000000" },
  "252": { landline: "2521200000", mobile: "252610000000" },
  "291": { landline: "29111200000", mobile: "29171200000" },
  "253": { landline: "25321300000", mobile: "25377000000" },
  "233": { landline: "233302000000", mobile: "233240000000" },
  "221": { landline: "221338000000", mobile: "221770000000" },
  "225": { landline: "2252720000000", mobile: "2250700000000" },
  "237": { landline: "237222000000", mobile: "237650000000" },
  "231": { landline: "23121000000", mobile: "231770000000" },
  "232": { landline: "23222000000", mobile: "23276000000" },
  "220": { landline: "2204200000", mobile: "2207000000" },
  "228": { landline: "22822200000", mobile: "22890000000" },
  "229": { landline: "22921000000", mobile: "22997000000" },
  "82": { landline: "82200000000", mobile: "821000000000" },
  "27": { landline: "27110000000", mobile: "27820000000" },
};

export function sampleForCountry(
  countryCode: string,
  type: "landline" | "mobile",
): string {
  return (
    AUTHORITATIVE_RATE_SAMPLES[countryCode]?.[type] ??
    `${countryCode}${type === "mobile" ? "900000000" : "200000000"}`
  );
}
